module.exports = {
      id: "ic-linebreak-normal-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-2c53a1.smartcharts.svg#ic-linebreak-normal-usage",
      toString: function () {
        return this.url;
      }
    }